import React, { useState, useEffect } from 'react';
import { fetchDashboardOrders } from '../apis/orders';
import { Chart } from 'primereact/chart';

import toast, { Toaster } from 'react-hot-toast';

import { ProgressSpinner } from 'primereact/progressspinner';

import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { fetchDashboardRiders } from '../apis/rider';
import { fetchDashboardUsers, fetchDashboardVendors } from '../apis/vendors';

export default function Dashboard() {

    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState(null);
    const [riderChartData, setRiderChartData] = useState(null);
    const [vendorChartData, setVendorChartData] = useState(null);
    const [userChartData, setUserChartData] = useState(null);


    const [statusFilter, setStatusFilter] = useState('');
    const statusOptions = [
        { label: 'Order', value: 'order' },
        { label: 'Riders', value: 'rider' },
        { label: 'Vendors', value: 'vendor' },
        { label: 'Users', value: 'user' },
    ];

    const getOrders = async () => {
        try {
            setLoading(true);
            const orders = await fetchDashboardOrders();
            if (orders.length > 0) {
                processChartData(orders);
            }
        } catch (error) {
            console.error("Error fetching Orders: ", error);
        } finally {
            setLoading(false);
        }
    };

    const getRiders = async () => {
        try {
            setLoading(true);
            const riders = await fetchDashboardRiders();
            // setOrders(riders);
            if (riders.length > 0) {
                processRidersData(riders);
            }
        } catch (error) {
            console.error("Error fetching Riders: ", error);
        } finally {
            setLoading(false);
        }
    };

    const getVednors = async () => {
        try {
            setLoading(true);
            const vendors = await fetchDashboardVendors();
            // setOrders(vendors);
            if (vendors.length > 0) {
                // processChartData(vendors);
                processVendorsData(vendors);
            }
        } catch (error) {
            console.error("Error fetching Vendors: ", error);
        } finally {
            setLoading(false);
        }
    };

    const getUsers = async () => {
        try {
            setLoading(true);
            const users = await fetchDashboardUsers();
            if (users.length > 0) {
                processUsersData(users);
            }
        } catch (error) {
            console.error("Error fetching Users: ", error);
        } finally {
            setLoading(false);
        }
    };

    const processChartData = (orders) => {
        const grouped = {};

        orders.forEach(order => {
            const date = new Date(order.createdAt).toISOString().split('T')[0];
            if (!grouped[date]) {
                grouped[date] = { count: 0, revenue: 0 };
            }
            grouped[date].count += 1;
            grouped[date].revenue += order.totalAmount || 0;
        });

        const labels = Object.keys(grouped).sort();
        const orderCounts = labels.map(date => grouped[date].count);
        const revenues = labels.map(date => grouped[date].revenue);

        setChartData({
            labels,
            datasets: [
                {
                    label: 'Orders per Day',
                    data: orderCounts,
                    fill: false,
                    borderColor: '#42A5F5',
                    backgroundColor: '#42A5F5',
                    tension: 0.4,
                    yAxisID: 'y',
                },
                {
                    label: 'Revenue per Day',
                    data: revenues,
                    fill: false,
                    borderColor: '#FFA726',
                    backgroundColor: '#FFA726',
                    tension: 0.4,
                    yAxisID: 'y1',
                }
            ]
        });
    };

    const processRidersData = (riders) => {
        const grouped = {};

        riders.forEach(order => {
            const date = new Date(order.createdAt).toISOString().split('T')[0];
            if (!grouped[date]) {
                grouped[date] = { count: 0, revenue: 0 };
            }
            grouped[date].count += 1;
        });

        const labels = Object.keys(grouped).sort();
        const riderCounts = labels.map(date => grouped[date].count);

        // Bar chart data
        setRiderChartData({
            labels,
            datasets: [
                {
                    label: 'New Riders',
                    data: riderCounts,
                    backgroundColor: '#66BB6A'
                }
            ]
        });
    }

    const processVendorsData = (riders) => {
        const grouped = {};

        riders.forEach(order => {
            const date = new Date(order.createdAt).toISOString().split('T')[0];
            if (!grouped[date]) {
                grouped[date] = { count: 0, revenue: 0 };
            }
            grouped[date].count += 1;
            // grouped[date].revenue += order.totalAmount || 0;
        });

        const labels = Object.keys(grouped).sort();
        const riderCounts = labels.map(date => grouped[date].count);

        // Bar chart data
        setVendorChartData({
            labels,
            datasets: [
                {
                    label: 'New Vendors',
                    data: riderCounts,
                    backgroundColor: '#6670bbff'
                }
            ]
        });
    }

    const processUsersData = (users) => {
        const grouped = {};

        users.forEach(order => {
            const date = new Date(order.createdAt).toISOString().split('T')[0];
            if (!grouped[date]) {
                grouped[date] = { count: 0, revenue: 0 };
            }
            grouped[date].count += 1;
        });

        const labels = Object.keys(grouped).sort();
        const userCounts = labels.map(date => grouped[date].count);
        
        // Bar chart data
        setUserChartData({
            labels,
            datasets: [
                {
                    label: 'New Users',
                    data: userCounts,
                    backgroundColor: '#66a7bbff'
                }
            ]
        });
    }

    const chartOptions = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: {
                    display: true,
                    text: 'Orders',
                },
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                title: {
                    display: true,
                    text: 'Revenue',
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };

    useEffect(() => {
        getOrders();
        getRiders();
        getVednors();
        getUsers();
    }, []);

    const handleApplyFilter = async () => {
        if (statusFilter.length === 0) {
            toast.error('Please Select a Report Type', {
                position: 'top-right'
            });
        } else {
            toast.success(`${statusFilter} Report Download Started`);

            if (statusFilter === 'order') {
                downloadCSV();
            } else if (statusFilter === 'rider') {
                downloadRidersCSV();
            } else if (statusFilter === 'vendor') {
                downloadVendorsCSV();
            } else if(statusFilter === 'user'){
                downloadUsersCSV();
            }
        }
    };

    const downloadCSV = () => {
        if (!chartData) return;

        let csv = 'S.No,Date,Orders,Revenue\n';
        chartData.labels.forEach((label, index) => {
            const orders = chartData.datasets[0].data[index];
            const revenue = chartData.datasets[1].data[index];
            csv += `${index + 1},${label},${orders},₹${revenue}\n`;
        });

        // Add UTF-8 BOM to ensure ₹ and other Unicode characters display correctly
        const BOM = '\uFEFF';  // Byte Order Mark for UTF-8
        const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });

        // const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'order_report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadRidersCSV = () => {
        if (!riderChartData) return;

        let csv = 'S.No,Date,Total Riders\n';
        riderChartData.labels.forEach((label, index) => {
            const riders = riderChartData.datasets[0].data[index];
            csv += `${index + 1},${label},${riders}\n`;
        });

        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'rider_report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadVendorsCSV = () => {
        if (!vendorChartData) return;

        let csv = 'S.No,Date,Total Vendors\n';
        vendorChartData.labels.forEach((label, index) => {
            const vendors = vendorChartData.datasets[0].data[index];
            csv += `${index + 1},${label},${vendors}\n`;
        });

        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'vendor_report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadUsersCSV = () => {
        if (!userChartData) return;

        let csv = 'S.No,Date,Total Users\n';
        userChartData.labels.forEach((label, index) => {
            const users = userChartData.datasets[0].data[index];
            csv += `${index + 1},${label},${users}\n`;
        });

        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'user_report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div className="card">

            <Toaster />
            <div className="flex flex-row gap-3 mb-2 filters">
                <Dropdown value={statusFilter} options={statusOptions} onChange={(e) => setStatusFilter(e.value)} placeholder="Type" />
                <Button icon={"pi pi-download"} label="Download Report" severity='success' onClick={handleApplyFilter} />
            </div>
            {loading && <ProgressSpinner />}
            {!loading && chartData && (
                <>
                    <div className="chart-grid" style={{ display: 'flex', gap: '2rem' }}>
                        <div style={{ flex: 1 }}>
                            <Chart type="line" data={chartData} options={chartOptions} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Chart type="bar" data={riderChartData} />
                        </div>
                    </div>
                    <div className="chart-grid" style={{ display: 'flex', gap: '2rem' }}>
                        <div style={{ flex: 1 }}>
                            <Chart type="bar" data={userChartData} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Chart type="bar" data={vendorChartData} />
                        </div>
                    </div>

                </>
            )}

        </div>
    );
}
